import { render, staticRenderFns } from "./ButtonTag.vue?vue&type=template&id=651887b6&scoped=true"
import script from "./ButtonTag.vue?vue&type=script&lang=ts"
export * from "./ButtonTag.vue?vue&type=script&lang=ts"
import style0 from "./ButtonTag.vue?vue&type=style&index=0&id=651887b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651887b6",
  null
  
)

export default component.exports